var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-container"},[_c('img',{staticClass:"background-image",attrs:{"src":require("@/assets/background-login.webp"),"alt":"Background"}}),_c('div',{staticClass:"overlay"})])
}]

export { render, staticRenderFns }